export class TransformInputModel {
  constructor(public source = '', public table = '', public lang = '') {}

  get isSurvey(): boolean {
    return this.lang !== '';
  }
}
